import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "live-chat",
  class LiveChat extends WYATTElement {
    connectedCallback() {
      this.trigger = this.querySelector("button");
      if (this.trigger) {
        this.trigger.addEventListener("click", this.toggleChat);
      }
    }

    toggleChat() {
      window.$zoho.salesiq.floatwindow?.visible("show");
    }

    disconnectedCallback() {
      super.disconnectedCallback();
    }
  },
);
